module.exports = __webpack_public_path__ + "img/bg_people_home_01_ex.6076e7fc.png";